import React, { useMemo } from 'react'
import AceEditor from 'react-ace'
import type { IAceEditorProps } from 'react-ace'
import { useTheme } from '@ztechapps/common.hook'

import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/theme-github'
import 'ace-builds/src-min-noconflict/ext-searchbox'

export type CodeEditorProps = IAceEditorProps

export const CodeEditor = ({ value, onChange, ...props }: CodeEditorProps) => {
  const theme = useTheme()
  const { isDark } = theme.colorMode

  const selectedTheme = useMemo(() => (isDark ? 'monokai' : 'github'), [isDark])

  return (
    <AceEditor
      mode="javascript"
      theme={selectedTheme}
      name="code-editor"
      onChange={(newValue) => {
        onChange(newValue)
      }}
      value={value}
      fontSize={14}
      width="100%"
      height="400px"
      wrapEnabled={true}
      showPrintMargin={false}
      showGutter={true}
      enableBasicAutocompletion={true}
      editorProps={{ $blockScrolling: Infinity }}
      enableLiveAutocompletion={true}
      setOptions={{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        showLineNumbers: true,
        tabSize: 2,
        useWorker: false,
      }}
      {...props}
    />
  )
}
